import React, { Component } from "react";
import { Button, Drawer, Input, Popover, Space, Tooltip } from "antd";
import actions from "@redux/EditableTable/actions";
import { connect } from "react-redux";
import {
  FilterOutlined,
  ImportOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

import Detail from "@components/Table/Detail";
import _ from "lodash";
import appActions from "@redux/app/actions";
import board from "@assets/images/login.jpg";
import styled from "styled-components";
import facilityActions from "@redux/facility/actions";
import { hasActiveFilters } from "@components/Table/filterState";

class PageHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      value: [],
      filter_dates: [],
      filterValues: null,
      globalSearch: "",
      isMobileFilterSearchDrawerOpen: false,
    };
  }

  handleImport = (e) => {
    this.props.onCloseImportModalRequest(false);
  };

  handleSelect = (e) => {
    this.props.handleSelect(e);
  };

  handleGlobalSearchChange = (event) => {
    const value = event.target.value;
    this.setState({
      globalSearch: value,
    });

    if (!value) {
      this.handleSelect(null);
    }
  };

  handleGlobalSearch = (value) => {
    const nextValue = value && value.trim() ? value.trim() : null;
    this.setState({
      globalSearch: nextValue || "",
    });
    this.handleSelect(nextValue);
  };

  handleRefresh = (e) => {
    this.props.handleFresh();
  };

  handleOpenNew = (e) => {
    this.props.clearSelectedAddress();

    this.setState({
      isOpenNew: true,
    });
  };

  onClose = (e) => {
    this.setState({
      isOpenNew: false,
    });
  };

  handOnlineSave = async (key, row) => {
    let result = await this.props.createRecords(row);
    // console.log('result', result)
    if (!(result?.response?.status > 299)) {
      this.setState({
        isOpenNew: false,
      });
      this.props.handleFresh();
    }
  };

  formRefCallback = (formRef) => {
    // console.log('formRefCallback', formRef)
    this.props.getFormRef(formRef);
  };

  renderDrawer = () => {
    return (
      <>
        <Drawer
          width={window.innerWidth > 900 ? "90%" : "100%"}
          placement="right"
          closable={false}
          onClose={this.onClose}
          visible={this.state.isOpenNew}
          destroyOnClose={true}
          autoFocus={true}
        >
          <div>
            {this.state.isOpenNew ? (
              <Detail
                formFields={this.props.formFields}
                handOnlineSave={this.handOnlineSave}
                columnProps={this.props.columnProps}
                formClassName={this.props.formClassName}
                isNewRecords={true}
                onClose={this.onClose}
                formRefCallback={this.formRefCallback}
              />
            ) : (
              ""
            )}
          </div>
        </Drawer>
      </>
    );
  };

  handleOpenFilters = () => {
    if (this.props.isPC === false) {
      this.setState({
        isMobileFilterSearchDrawerOpen: true,
      });
      return;
    }

    this.setState({
      isOpenFilters: true,
    });
  };

  handleCloseMobileFilterSearch = () => {
    this.setState({
      isMobileFilterSearchDrawerOpen: false,
    });
  };

  handleFilterChange = (filterValues, originalHandleFilter) => {
    this.setState({
      filterValues,
    });

    if (typeof originalHandleFilter === "function") {
      return originalHandleFilter(filterValues);
    }
  };

  handleResetFilters = () => {
    this.setState({
      filterValues: null,
      globalSearch: "",
    });

    this.handleSelect(null);

    if (typeof this.props.resetFilters === "function") {
      return this.props.resetFilters();
    }
  };

  enhanceFilterContent = (filterContent) => {
    if (Array.isArray(filterContent)) {
      return filterContent.map(this.enhanceFilterContent);
    }

    if (!React.isValidElement(filterContent)) {
      return filterContent;
    }

    const enhancedChildren = React.Children.map(
      filterContent.props?.children,
      this.enhanceFilterContent
    );

    const nextProps = enhancedChildren !== undefined ? { children: enhancedChildren } : {};
    const componentName =
      filterContent.type?.displayName ||
      filterContent.type?.name ||
      filterContent.type?.render?.displayName ||
      filterContent.type?.render?.name;
    const isFilterAwareElement =
      typeof filterContent.props?.handleFilter === "function" ||
      typeof filterContent.props?.onFilterValueChange === "function" ||
      typeof filterContent.props?.SelectedLookup_CommonRequest === "function" ||
      typeof filterContent.props?.Lookup_CommonupRequest === "function" ||
      typeof filterContent.props?.request === "function" ||
      ["SearchLookup", "AutoSearchSelect", "ResponsiveSelect"].includes(componentName);

    if (isFilterAwareElement) {
      nextProps.handleFilter = (filterValues) =>
        this.handleFilterChange(filterValues, filterContent.props.handleFilter);
      nextProps.onFilterValueChange = (filterValues) =>
        this.handleFilterChange(filterValues, filterContent.props.onFilterValueChange);
    }

    return React.cloneElement(filterContent, nextProps);
  };

  renderFilterContent = () => {
    if (typeof this.props.renderFilter === "undefined") {
      return "";
    }

    return this.enhanceFilterContent(this.props.renderFilter());
  };

  renderFilterArea = () => {
    if (typeof this.props.renderFilter === "undefined") {
      return "";
    }

    if (this.props.isPC === false) {
      return "";
    }

    return this.renderFilterContent();
  };

  renderFilterSearchContent = () => {
    const isMobile = this.props.isPC === false;

    return (
      <div className="mt-3 text-center table-page-header-filter-search-content">
        <div className="flex justify-between items-center border-b-2 py-2 table-page-header-filter-search-reset-row">
          <div></div>
          <button
            className="text-blue-600 font-bold uppercase px-6 py-2 rounded"
            onClick={this.handleResetFilters}
          >
            Reset
          </button>
        </div>
        <div className="mt-2 px-7 py-3 table-page-header-filter-search-fields">
          {isMobile ? this.renderMobileFilterSearchFields() : (
            <div className="mb-4">
              {this.renderSearchContent()}
            </div>
          )}
        </div>
      </div>
    );
  };

  renderMobileFilterSearchDrawer = () => {
    return (
      <Drawer
        placement="bottom"
        height="72vh"
        title="Filter and search"
        className="table-page-header-mobile-filter-drawer"
        visible={this.state.isMobileFilterSearchDrawerOpen}
        onClose={this.handleCloseMobileFilterSearch}
        destroyOnClose={false}
      >
        <div className="table-page-header-mobile-filter-content">
          {this.renderFilterSearchContent()}
        </div>
      </Drawer>
    );
  };

  renderSearchContent = () => {
    if (typeof this.props.renderSearches === "undefined") {
      return "";
    }

    return this.enhanceFilterContent(this.props.renderSearches());
  };

  renderMobileFilterSearchFields = () => {
    const fields = [];
    const shouldRenderGlobalSearch = this.props.hide_search === false;
    const hasRenderSearches = typeof this.props.renderSearches === "function";
    const hasRenderFilter = typeof this.props.renderFilter === "function";
    const isSameFilterRenderer =
      hasRenderSearches &&
      hasRenderFilter &&
      this.props.renderSearches === this.props.renderFilter;

    if (shouldRenderGlobalSearch) {
      fields.push(
        <div key="global-search" className="mb-4 table-page-header-mobile-filter-field">
          {this.renderGlobalSearchInput(true)}
        </div>
      );
    }

    if (hasRenderSearches) {
      fields.push(
        <div key="searches" className="mb-4 table-page-header-mobile-filter-field">
          {this.renderSearchContent()}
        </div>
      );
    }

    if (hasRenderFilter && !isSameFilterRenderer) {
      fields.push(
        <div key="filters" className="mb-4 table-page-header-mobile-filter-field">
          {this.renderFilterContent()}
        </div>
      );
    }

    return fields;
  };

  hasMobileFilterSearchContent = () =>
    this.props.hide_search === false ||
    typeof this.props.renderSearches === "function" ||
    typeof this.props.renderFilter === "function" ||
    typeof this.props.resetFilters !== "undefined";

  renderFilterSearchButton = (filterHasValue) => {
    if (
      this.props.isPC === false &&
      !this.hasMobileFilterSearchContent()
    ) {
      return null;
    }

    if (this.props.isPC !== false && typeof this.props.resetFilters === "undefined") {
      return <div className={"ml-5 px-3"} />;
    }

    const button = (
      <Tooltip title="Filter and search">
        <Button
          key="button4"
          type="default"
          shape="circle"
          icon={
            <FilterOutlined
              className="table-page-header-filter-icon"
            />
          }
          className={[
            "table-page-header-icon-btn",
            filterHasValue ? "table-page-header-icon-btn--filtered" : "",
          ].filter(Boolean).join(" ")}
          onClick={this.handleOpenFilters}
          aria-label="Filter and search"
        />
      </Tooltip>
    );

    if (this.props.isPC === false) {
      return button;
    }

    return (
      <Popover
        content={this.renderFilterSearchContent()}
        trigger="click"
        placement="bottomRight"
      >
        {button}
      </Popover>
    );
  };

  renderGlobalSearch = () => {
    return this.renderGlobalSearchInput(false);
  };

  renderGlobalSearchInput = (isDrawer = false) => {
    if (this.props.hide_search !== false) {
      return null;
    }

    return (
      <Input.Search
        allowClear
        enterButton
        className="table-page-header-global-search"
        placeholder="Search"
        value={this.state.globalSearch}
        onChange={this.handleGlobalSearchChange}
        onSearch={this.handleGlobalSearch}
        style={{ width: isDrawer ? "100%" : this.props.isPC === false ? 180 : 260 }}
      />
    );
  };

  render() {
    const { endToolbarSlot } = this.props;
    const filterHasValue = hasActiveFilters(
      this.props.filterHasValue,
      this.props.filterValues,
      this.state.filterValues,
      this.props.filter_dates,
      this.props.filterDescription
    );
    return (
      <div
        className={
          (endToolbarSlot
            ? " table-page-header--root table-page-header--pro-toolbar-embedded -mx-3 items-center w-full"
            : " table-page-header--root -mx-3 items-center w-full")
        }
      >
        <div className=" lg:w-auto flex items-center justify-between px-3">
          <div>{/* {this.props.filterDescription} */}</div>
        </div>
        <div
          className={
            endToolbarSlot
              ? "table-page-header-toolbar-band max-w-full px-3 flex flex-nowrap items-center justify-start min-w-0"
              : "table-page-header-toolbar-band max-w-full px-3 flex flex-nowrap items-center justify-start min-w-0 mt-2"
          }
        >
          <div
            className={[
              "flex table-page-header-main-row table-page-header-main-row--split filter-item justify-between w-full min-w-0 items-center",
              this.props.isPC === false ? "table-page-header-main-row--mobile-filter-icon-only" : "",
            ].filter(Boolean).join(" ")}
          >
            <div className="table-page-header-filter-aux flex flex-nowrap items-center justify-start gap-3 min-w-0 flex-1">
              {this.props.isPC === false ? null : this.renderGlobalSearch()}
              {this.props.isPC === false ? null : this.renderFilterArea()}
            </div>

            {!this.props.isHideRefreshNews && (
              <div className={"flex items-center table-page-header-actions"}>
                <Space size={8} align="center" wrap={false} className="table-page-header-icon-group">
                {this.props.renderButtons ? this.props.renderButtons() : null}
                {this.props.hide_imports ? (
                  null
                ) : (
                  <Tooltip title="Import from file">
                    <Button
                      key="button0"
                      type="default"
                      shape="circle"
                      className="table-page-header-icon-btn"
                      icon={<ImportOutlined />}
                      onClick={this.handleImport}
                      aria-label="Import from file"
                    />
                  </Tooltip>
                )}

                <Tooltip title="Refresh list">
                  <Button
                    key="button1"
                    type="default"
                    shape="circle"
                    className="table-page-header-icon-btn reload-refresh-btn"
                    icon={<ReloadOutlined />}
                    onClick={this.handleRefresh}
                    aria-label="Refresh list"
                  />
                </Tooltip>

                {!this.props.hid_new ? (
                  <Tooltip
                    title={
                      this.props.new_text
                        ? this.props.new_text
                        : "Create new record"
                    }
                  >
                    <Button
                      key="button2"
                      type="default"
                      shape="circle"
                      className="table-page-header-icon-btn"
                      icon={<PlusOutlined />}
                      onClick={
                        typeof this.props.onNew === "function"
                          ? this.props.onNew
                          : this.handleOpenNew
                      }
                      aria-label={
                        this.props.new_text
                          ? this.props.new_text
                          : "Create new record"
                      }
                    />
                  </Tooltip>
                ) : (
                  null
                )}

                {this.props.toolBarRender && this.props.toolBarRender()}

                {this.renderFilterSearchButton(filterHasValue)}
                {endToolbarSlot ? (
                  <span className="table-page-header-end-slot flex items-center">
                    {endToolbarSlot}
                  </span>
                ) : null}
                </Space>
              </div>
            )}
          </div>
        </div>
        {this.state.isOpenNew ? this.renderDrawer() : ""}
        {this.props.isPC === false && this.hasMobileFilterSearchContent()
          ? this.renderMobileFilterSearchDrawer()
          : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const role = _.get(state, "Auth.role", {});
  const Role = role && Object.keys(role)[0];
  return {
    Role: Role,
    isPC: state.App?.isPC,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCurrent: (e) => dispatch(appActions.changeCurrent(e)),
    OpenDrawer: (e, id) => dispatch(actions.OpenDrawer(e, id)),
    clearSelectedAddress: () => dispatch(facilityActions.SelectedAddress("")),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);
